export const platformAdminNavigation = {
  links: {
    portal: "门户",
    platformAdmin: "平台后台",
    examAdmin: "考试后台",
  },
  menu: {
    domainOverview: "总览",
    domainPortal: "门户",
    domainGovernance: "治理",
    domainResource: "资源",
    domainRuntime: "运行",
    domainCapability: "能力",
    dashboard: "平台概览",
    applications: "业务入口",
    portalManagement: "门户管理",
    portalGroups: "门户分组",
    portalAppearance: "门户外观",
    portalUiSemantics: "UI 语义概览",
    portalEntries: "入口编排",
    portalAccess: "接入设置",
    portalSecurity: "安全策略",
    identity: "统一身份",
    identityApplications: "身份接入应用",
    identityUsers: "平台用户",
    identityTenants: "租户",
    identityOrganizations: "组织",
    identityRoles: "平台角色",
    identityPermissions: "权限点",
    identityEvents: "身份审计",
    identityLoginRecords: "登录记录",
    identityUserCustomFields: "用户自定义字段",
    assets: "资产中心",
    execution: "执行底座",
    centers: "平台入口与中心",
  },
} as const;
